import React from 'react';
import * as utils from "../../../utils/utils";

export default class Port extends React.Component {
    getMovement() {
        let ports = this.props.row.cargoPorts;

        if (utils.notNullNorUndefined(ports)) {
            for (let i = 0; i < ports.length; i++) {
                if (ports[i].operation === this.props.operation) {
                    return ports[i].port.name;
                }
            }
        }

        return null;
    }

    render() {
        let movement = this.getMovement();
        return <span>{movement}</span>;
    }
}


// WEBPACK FOOTER //
// ./src/components/cargo/tableComponents/Port.js